module.exports = __webpack_public_path__ + "static/media/z-pm-1618054-unsplash.9249cb70.jpg";